import { type IntlShape, defineMessage } from 'react-intl'

export const middleDotSeparatorMessage = defineMessage({
  id: 'eD+bIGki/X',
  defaultMessage: '·',
  description: 'Middle dot separator character used between items',
})

export const pipeSeparatorMessage = defineMessage({
  id: '1LMy5j0nsD',
  defaultMessage: '|',
  description: 'Pipe separator character used between items',
})

export const bulletSeparatorMessage = defineMessage({
  id: 'UO0e3sXu/k',
  defaultMessage: '•',
  description: 'Bullet separator character used between items',
})

export const arrowSeparatorMessage = defineMessage({
  id: 'sMq7ziIdq9',
  defaultMessage: '→',
  description: 'Right arrow separator character used between origin and destination',
})

export const dashSeparatorMessage = defineMessage({
  id: 'xlJFvjnOo3',
  defaultMessage: '-',
  description: 'Dash separator character used between items such as date ranges',
})

export const ampersandSeparatorMessage = defineMessage({
  id: 'wWrhf09fjh',
  defaultMessage: '&',
  description: 'Ampersand separator character used between items',
})

export function formatMiddleDotSeparator(intl: IntlShape): string {
  return ` ${intl.formatMessage(middleDotSeparatorMessage)} `
}

export function formatPipeSeparator(intl: IntlShape): string {
  return ` ${intl.formatMessage(pipeSeparatorMessage)} `
}

export function formatBulletSeparator(intl: IntlShape): string {
  return ` ${intl.formatMessage(bulletSeparatorMessage)} `
}

export function formatArrowSeparator(intl: IntlShape): string {
  return ` ${intl.formatMessage(arrowSeparatorMessage)} `
}

export function formatDashSeparator(intl: IntlShape): string {
  return ` ${intl.formatMessage(dashSeparatorMessage)} `
}

export function formatAmpersandSeparator(intl: IntlShape): string {
  return ` ${intl.formatMessage(ampersandSeparatorMessage)} `
}
